import { createRequestActions } from "common/helpers/action";

export const initKkmList = createRequestActions("KKM.LIST.INIT");
export const scrollKkmList = createRequestActions("KKM.LIST.SCROLL");
export const searchKkmList = createRequestActions("KKM.LIST.SEARCH");
export const filterKkmList = createRequestActions("KKM.LIST.FILTER");
